import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { navigate } from 'gatsby';
import BlogPostCard from './components/BlogPostCard';
import BlogPostNavigationHeader from './components/BlogPostNavigationHeader';
import BlogSearch from './components/BlogSearch/BlogSearch';
import SlideReveal from '../../modules/animations/components/Reveal/variants/SlideReveal/SlideReveal';
import { PaginatedGrid } from '../../modules/foundation/components';
import { BlogPostPropType } from '../../services/proptypes';
import './BlogPostNavigation.css';
var defaultProps = {
  title: 'Blog',
  description: '',
  columns: 4,
  alwaysShowSearch: true,
  hideSearch: false,
  featuredPostId: null,
  pageSize: 12,
  tight: false,
  blogRootSlug: '/blog/',
  dateFormat: 'PPP'
};
var BlogPostNavigation = /*#__PURE__*/function (_React$Component) {
  _inherits(BlogPostNavigation, _React$Component);
  var _super = _createSuper(BlogPostNavigation);
  function BlogPostNavigation(props) {
    var _this;
    _classCallCheck(this, BlogPostNavigation);
    _this = _super.call(this, props);
    _this.state = {
      searchQuery: '',
      searchResults: [],
      searchLoading: false
    };
    _this.onResultSelect = _this.onResultSelect.bind(_assertThisInitialized(_this));
    _this.onSearchChange = _this.onSearchChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(BlogPostNavigation, [{
    key: "onResultSelect",
    value: function onResultSelect(e, _ref) {
      var slug = _ref.result.slug;
      navigate("".concat(slug, "/"));
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(e, _ref2) {
      var _this2 = this;
      var value = _ref2.value;
      this.setState({
        searchQuery: value,
        searchLoading: true
      }, function () {
        var searchResults = _this2.getFilteredPosts();
        _this2.setState({
          searchResults: searchResults,
          searchLoading: false
        });
      });
    }
  }, {
    key: "getFilteredPosts",
    value: function getFilteredPosts() {
      var posts = this.props.posts;
      var searchQuery = this.state.searchQuery;
      var re = new RegExp(searchQuery, 'i');
      var isMatch = function isMatch(text) {
        return re.test(text);
      };
      return posts.filter(function (_ref3) {
        var title = _ref3.title,
          content = _ref3.content,
          summary = _ref3.summary;
        return isMatch(title) || isMatch(summary) || isMatch(content);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        searchQuery = _this$state.searchQuery,
        searchLoading = _this$state.searchLoading,
        searchResults = _this$state.searchResults;
      var _this$props = this.props,
        posts = _this$props.posts,
        title = _this$props.title,
        description = _this$props.description,
        featuredPostId = _this$props.featuredPostId,
        columns = _this$props.columns,
        alwaysShowSearch = _this$props.alwaysShowSearch,
        hideSearch = _this$props.hideSearch,
        pageSize = _this$props.pageSize,
        tight = _this$props.tight,
        blogRootSlug = _this$props.blogRootSlug,
        dateFormat = _this$props.dateFormat;
      // if nothing is being searched, make sure to always display all posts
      var displayablePosts = searchQuery.length === 0 ? posts : searchResults;
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-post-navigation"
      }, /*#__PURE__*/React.createElement(BlogPostNavigationHeader, {
        posts: posts,
        title: title,
        description: description,
        featuredPostId: featuredPostId
      }), (posts.length > columns - 1 || alwaysShowSearch) && !hideSearch && /*#__PURE__*/React.createElement(BlogSearch, {
        value: searchQuery,
        onResultSelect: this.onResultSelect,
        onSearchChange: this.onSearchChange,
        searchResults: searchResults,
        loading: searchLoading
      }), displayablePosts.length > 0 && /*#__PURE__*/React.createElement(PaginatedGrid, {
        className: "blog-cards",
        columns: columns,
        rows: Math.ceil(pageSize / columns),
        mobile: {
          columns: 1,
          rows: pageSize,
          stackable: true
        },
        tablet: {
          doubling: true
        },
        items: displayablePosts.map(function (post) {
          return /*#__PURE__*/React.createElement(SlideReveal, {
            direction: "up",
            fade: true,
            triggerOnce: true
          }, /*#__PURE__*/React.createElement(BlogPostCard
          /* eslint-disable-next-line no-underscore-dangle */, _extends({
            key: post.id || post._id,
            blogRootSlug: blogRootSlug
          }, post, {
            dateFormat: dateFormat
          })));
        }),
        tight: tight
      }), displayablePosts.length === 0 && /*#__PURE__*/React.createElement("p", null, " No posts found "));
    }
  }]);
  return BlogPostNavigation;
}(React.Component);
export { BlogPostNavigation as default };
BlogPostNavigation.defaultProps = defaultProps;